/**
 * Store timeslots in redux as
 */
export const STORE_TIMESLOT_AS = 'timeslot/month';
